@for (item of [1,2]; track $index) {
<div class="global-card mb-3 py-3">
  <div class="d-flex justify-content-between align-items-center">
    <div>
      <p-skeleton styleClass="mb-1" height="1.2rem" width="100px" />
      <p-skeleton styleClass="mb-1" height="1.2rem" width="150px" />
    </div>
    <div class="d-flex gap-1">
      <p-skeleton styleClass="mb-1" height="1.5rem" width="100px" />
      <p-skeleton styleClass="mb-1" height="1.5rem" width="100px" />
    </div>
  </div>

  <div class="d-flex justify-content-between align-items-center mt-3">
    <div>
      <p-skeleton styleClass="mb-1" height="1.2rem" width="100px" />
    </div>
    <div class="d-flex gap-1">
      <p-skeleton styleClass="mb-1" height="1.2rem" width="100px" />
    </div>
  </div>

  <div class="row g-3 w-100 mt-3">
    @for (item of [1,2,3,4]; track $index) {
    <div class="col-xl-3 col-md-4 col-sm-6 col-12">
      <p-skeleton styleClass="mb-1" height="6rem" width="100%" />
    </div>
    }
  </div>
</div>
}